import type { StatusTone } from '@/lib/status-tones'
import type { QuoteStatus, WorkflowStageStatus } from '../api/types'

export const quoteStatusLabels: Record<QuoteStatus, string> = {
  started: 'Started',
  draft: 'Draft',
  sent: 'Sent',
  viewed: 'Viewed',
  approved: 'Approved',
  rejected: 'Lost',
  expired: 'Expired',
  archived: 'Archived',
}

export const quoteStatusTones: Record<QuoteStatus, StatusTone> = {
  started: 'neutral',
  draft: 'neutral',
  sent: 'progress',
  viewed: 'warning',
  approved: 'success',
  rejected: 'danger',
  expired: 'warning',
  archived: 'neutral',
}

export const stageStatusLabels: Record<WorkflowStageStatus, string> = {
  complete: 'Complete',
  attention: 'Needs attention',
  unavailable: 'Not ready',
}
